
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';

import { MDBBootstrapModule } from 'angular-bootstrap-md';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { NavbarComponent } from './navbar/navbar.component';
import { LandingpageComponent } from './landingpage/landingpage.component';
import { SplashComponent } from './splash/splash.component';
import { RouterModule } from '@angular/router';
import { TeamComponent } from './team/team.component';
import { FooterComponent } from './footer/footer.component';
import { ImpressumComponent } from './impressum/impressum.component';
import { DatenschutzComponent } from './datenschutz/datenschutz.component';
import { MapComponent } from './map/map.component';
import { MissionComponent } from './mission/mission.component';
import { MottoComponent } from './motto/motto.component';
import { TierpaedagogikComponent } from './tierpaedagogik/tierpaedagogik.component';
import { MethodenComponent } from './methoden/methoden.component';
import { GalleryComponent } from './gallery/gallery.component';
import { LeistungsangebotComponent } from './leistungsangebot/leistungsangebot.component';
import { KonzeptComponent } from './konzept/konzept.component';
import { ImpressionenComponent } from './impressionen/impressionen.component';

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    LandingpageComponent,
    SplashComponent,
    TeamComponent,
    FooterComponent,
    ImpressumComponent,
    DatenschutzComponent,
    MapComponent,
    MissionComponent,
    MottoComponent,
    TierpaedagogikComponent,
    MethodenComponent,
    GalleryComponent,
    LeistungsangebotComponent,
    KonzeptComponent,
    ImpressionenComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MDBBootstrapModule.forRoot(),
    FormsModule,
    AppRoutingModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
